import {REGEX_COMMUNITY_REPLY} from '../../../core/entities/community/constants';
import {isReply} from './isReply';

export const getSeqNumberReplyTo = (body: string): number | undefined => {
  if (!isReply(body)) return undefined;

  const match = REGEX_COMMUNITY_REPLY.exec(body);
  if (!match) return undefined;

  const seqNumber = match[0].replace('>>', '');
  return Number.parseInt(seqNumber, 10);
};
